module.exports = __webpack_public_path__ + "static/media/13.a1f09f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/13.png
// module id = 930
// module chunks = 0